#import "../fragments/account-hierarchy-info-fragment.graphql"

mutation AddAccountParentRelationship($input: AccountParentSetInput!) {
    accountParentSet(input: $input) {
        account {
            ...AccountHierarchyInfoFragment
        }
        parentAccount {
            ...AccountHierarchyInfoFragment
        }
    }
}
